import clsx from 'clsx'
import { ReactNode } from 'react'

export type SmallInfoCardProps = {
  title: string
  value: string
  icon?: string
  iconNode?: ReactNode
  containerClassName?: string
}

export const SmallInfoCard = ({
  title,
  value,
  icon,
  iconNode,
  containerClassName = 'bg-white',
}: SmallInfoCardProps) => {
  return (
    <div
      className={clsx(
        'flex h-full min-h-0 w-full flex-1 flex-col items-center gap-4 rounded-2xl p-6 shadow-[0_4px_12px_rgba(0,0,0,0.08)]',
        containerClassName
      )}
    >
      {iconNode ?? (
        icon ? (
          <img src={icon} height={64} width={64} alt="" className="h-16 w-16 shrink-0 object-contain" />
        ) : null
      )}
      <div className="w-full min-w-0 text-center">
        <span className="mb-2 block text-[1.15rem] font-bold leading-snug text-primary2">
          {title}
        </span>
        <span className="block wrap-break-words text-base font-medium leading-snug">
          {value}
        </span>
      </div>
    </div>
  )
}
